module.exports = __webpack_public_path__ + "static/media/icon-logout.35efca45.svg";